module.exports = __webpack_public_path__ + "img/text2.00029356.png";